import * as React from 'react'
import {
  Grid,
  Typography,
  Paper,
  Button,
  Menu,
  MenuItem,
  Link as MuiLink
} from '@mui/material'
import { useStore } from 'effector-react'
import $auth from '../../Auth/store'
import { Link } from 'react-router-dom'

export default function Header() {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const accessFlags = useStore($auth).accessFlags.paidServices

  return (
    <>
      <Paper
        sx={{ mt: 3, padding: '1rem', borderRadius: '1rem' }}
        elevation={0}
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Typography variant="h4" fontWeight="bold" color="black">
              Платные услуги
            </Typography>
          </Link>
          <Grid justifyContent="space-between">
            <Button
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              Меню
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button'
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
            >
              {accessFlags.search && (
                <MenuItem>
                  <Link to="/">Услуги</Link>
                </MenuItem>
              )}
              {accessFlags.reports && (
                <MenuItem>
                  <Link to="/reports">Отчеты</Link>
                </MenuItem>
              )}
              {Object.values(accessFlags.settings || {}).some((f) => f) && (
                <MenuItem>
                  <Link to="/settings">Настройки</Link>
                </MenuItem>
              )}
              <MenuItem>
                <Link to="/license">Лицензия</Link>
              </MenuItem>
              <MenuItem>
                <MuiLink
                  target="_blank"
                  href="https://crm.vdkanal.ru/bitrix/tools/disk/focus.php?folderId=884277&action=openFolderList&ncc=1"
                >
                  Инструкции
                </MuiLink>
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Paper>
    </>
  )
}
